<template>
  <div class="settings">

    <div class="color-form form-group">
      <label class="color-label"
             for="color-input">
             {{ usernameColorPickerText }}
      </label>
      <compact id="color-input"
               class="color-picker"
               v-model="colors"
               :palette="palette" />
    </div>

    <div class="language-form form-group">
      <label class="language-label"
             for="language-input">
             {{ languageSelectText }}
      </label>
      <select id="language-input"
              class="language-select form-control form-control-sm"
              v-model="languageInput">
        <option v-for="option in languages"
                :value="option.code">
                {{ option.text }}
        </option>
      </select>
    </div>

    <div class="time-form form-check">
      <label class="form-check-label time-label">
        <input class="form-check-input time-input"
               type="checkbox"
               v-model="showMessageTimeInput">
               {{ showMessageTimeCheckboxText }}
      </label>
    </div>

    <div class="button-form">
      <button type="button"
              class="btn btn-sm btn-outline-primary"
              v-on:click="logout">
              {{ logoutButtonText }}
      </button>

      <button type="button"
              class="btn btn-sm btn-outline-primary"
              v-on:click="clear">
              {{ clearMessagesButtonText }}
      </button>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { Compact } from 'vue-color'

export default {
  name: 'Settings',

  components: {
    Compact
  },

  data: function () {
    return {
      showMessageTimeInput: '',
      languageInput: '',
      colors: ''
    }
  },

  mounted: function () {
    this.showMessageTimeInput = this.showMessageTime
    this.languageInput = this.language
    this.colors = this.usernameColor
  },

  computed: {
    ...mapGetters([
      'showMessageTimeCheckboxText',
      'usernameColorPickerText',
      'clearMessagesButtonText',
      'languageSelectText',
      'logoutButtonText',
      'showMessageTime',
      'usernameColor',
      'languages',
      'language',
      'palette'
    ])
  },

  methods: {
    ...mapMutations([
      'setShowMessageTime',
      'setUsernameColor',
      'clearMessages',
      'setLanguage'
    ]),

    ...mapActions([
      'disconnect'
    ]),

    logout: function (event) {
      this.disconnect()
    },

    clear: function (event) {
      this.clearMessages()
    }
  },

  watch: {
    colors: function (selectedColor) {
      this.setUsernameColor({ color: selectedColor })
    },

    showMessageTimeInput: function (showMessageTime) {
      this.timeInput = showMessageTime
      this.setShowMessageTime({ showMessageTime: showMessageTime })
    },

    languageInput: function (language) {
      this.languageInput = language
      this.setLanguage({ language: language })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';

.form-control, .form-check-input {
  border-color: $border-color;
  outline: none;

  &:focus {
    border-color: $border-color;
    box-shadow: none;
    outline: none;
  }
}

.btn {
  &:focus, &active {
    box-shadow: none;
    outline: none !important;
  }
}

@mixin padding {
  padding-left: 5px;
}

.color-form,
.language-form,
.time-form {
  margin-bottom: 10px;
}

.button-form {
  margin-bottom: 5px;
}

.color {
  &-picker {
    box-shadow: none !important;
  }

  &-label {
    @include padding;
    margin-bottom: 0px;
  }
}

.time {
  &-label {
    padding-left: 25px;
  }
}

.language {
  &-label {
    margin-bottom: 5px;
  }

  &-select {
    width: 70%;
  }

  &-form {
    @include padding;
  }
}

.button-form {
  @include padding;
}
</style>



// WEBPACK FOOTER //
// src/components/Settings.vue